import { h, Component } from 'preact';
import { BrowserRouter, Route, Switch, StaticRouter, matchPath } from 'react-router-dom';
import axios from 'axios';
import classnames from 'classnames/dedupe';
import get from 'lodash.get';
import Cookies from 'universal-cookie';

import Ga from '../analytics';
import Header from '../header';
import Search from '../search';
import Footer from '../footer';
import { DEFAULT_HOSTNAME, GET_USER_API_PATH } from '../../helpers/constants';
import { getCurrentCity } from '../../helpers';
import { isIphone } from '../../helpers/userAgent';
import MediaQuery from '../../hoc/mediaQuery';

import styles from './index.scss';
import NotificationPopup from '../notificationPopup';
import notificationSupportedRoutes from '../notificationPopup/notificationSupportedRoutes';

const RouterWrapper = ({ children, location }) => {
	if (typeof window !== 'undefined') {
		return (
			<BrowserRouter>
				{children}
			</BrowserRouter>
		);
	}
	return (
		<StaticRouter location={location} context={{}}>
			{children}
		</StaticRouter>
	);
};

const cookies = new Cookies();

/**
* Shell - Wraps your app with Quikr's Header and Footer
* It accepts a config array - you can vary the behaviour of header and footer based on routes
* Example - View app.js
*
*/
class Shell extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userInfo: {
				loggedIn: false
			},
			headerHeight: 0,
			walletBalance:-1
		};
	}


	/**
	* This method is called whenever the props or state changes
	* @return {Object} Context of child components
	*/
	getChildContext() {
		const context = {};
		const { isDesktop = false } = this.props;
		context.user = this.state.userInfo;
		context.quikr = {
			city: getCurrentCity()
		};
		if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
			context.device = {
				userAgent: get(navigator,'userAgent','')
			};
		}
		context.walletBalance = this.state.walletBalance;
		if (isDesktop) {
			context.screenWidth = 1920;
		} else {
			context.screenWidth = 384;
		}
		return context;
	}
	componentDidMount() {
		this.getUser();
	}

	componentDidUpdate(prevProps, prevState) {
		try {
			const height = document.getElementById('qhswrap').clientHeight;
			if (height !== prevState.headerHeight) {
				this.setState({
					headerHeight: height
				});
			}
		} catch (e){}
	}

	updateWalletBalance=(amount)=>{
		this.setState({
			walletBalance: amount
		});

	}
	getUser = () => {
		let hostname = DEFAULT_HOSTNAME;
		if (window && window.location && window.location.hostname) {
			hostname = window.location.hostname;
		}
		axios.get(`https://${hostname}/${GET_USER_API_PATH}`).then((res) => {
			if (res.status === 200 && res.data) {
				this.setState({
					userInfo: res.data
				});
			} else {
				this.resetUser();
			}
		}).catch(() => {
			this.resetUser();
		});
	}

	resetUser = () => {
		this.setState({
			userInfo: {
				loggedIn: false
			}
		});
	};

	getPageType = (pageTypeStringOrFunction, route) => {

		if (typeof pageTypeStringOrFunction === 'function' && typeof window !== 'undefined') {
			// const { location } = this.props;
			const { location } = window;
			const match = matchPath(location.pathname,{...route} );
			return pageTypeStringOrFunction(location, match);
		} else if (typeof pageTypeStringOrFunction === typeof 'a') {
			return pageTypeStringOrFunction;
		}
		return 'other';
	}

	render(props, state) {
		const { config, children, location ,pPerformance} = this.props;
		const { userInfo, headerHeight } = this.state;
		let divClassName = 'actual-app';
		// console.log('Children here => ', children);

		if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
			divClassName = classnames('actual-app',{ 'ios-clickable': isIphone(get(navigator,'userAgent','')) });
		}

		return (<RouterWrapper location={location} pPerformance={pPerformance}>
			<div className={divClassName}>
				<Switch>
					{config.map(c => (<Route {...c.route} render={(routeProps)=> <Ga {...routeProps} {...c.ga} pPerformance={c.pPerformance} qrum={c.qrum} />} />))}
					<Route  render={(routeProps)=> <Ga {...routeProps} />} />
				</Switch>
				<Switch>
					{notificationSupportedRoutes.map((c, i) => (<Route key={i} {...c.route} render={(routeProps)=> <NotificationPopup {...routeProps} userInfo={userInfo} {...c.notification} />}  />))
					}
				</Switch>
				<Switch>
					{config.map(headerConfig => (<Route {...headerConfig.route}>
						<div class={classnames('q__hs_wrap', 'mdc-toolbar-shadow', { 'mdc-toolbar--fixed': headerConfig.sticky }, styles && styles['q__hs_wrap'])} id={headerConfig.sticky ? 'qhswrap' : null}>
							<Switch>
								{config.map(c => (<Route {...c.route} render={(propsForHeader)=><Header {...propsForHeader} {...c.header} userInfo={userInfo} getPageType={() => this.getPageType(c.pageType, c.route)} pPerformance={c.pPerformance} g_id={c.g_id}  searchProps={c.search}/>} />))}
								<Route >
									<Header show hasTitle userInfo={userInfo} g_id={headerConfig.g_id} searchProps={headerConfig.search}/>
								</Route>
							</Switch>
							<Switch>
								{config.map(c => (<Route {...c.route} >
									<MediaQuery maxWidth={840}>
										<Search {...c.search} userInfo={userInfo} pPerformance={c.pPerformance} getPageType={() =>this.getPageType(c.pageType, c.route)}  updateWalletBalance={this.updateWalletBalance}/>
									</MediaQuery>
								</Route>))}
								<Route >
									<MediaQuery maxWidth={840}>
										<Search show />
									</MediaQuery>
								</Route>
							</Switch>
						</div>
					</Route>
					))}
					<Route >
						<div class={classnames('q__hs_wrap','mdc-toolbar-shadow')}>
							<Switch>
								<Route>
									<Header show hasTitle userInfo={userInfo} searchProps={{show: true}}/>
								</Route>
							</Switch>
							<Switch>
								<Route>
									<MediaQuery maxWidth={840}>
										<Search show userInfo={userInfo}/>
									</MediaQuery>
								</Route>
							</Switch>
						</div>
					</Route>
				</Switch>

				<div className="body-content" style={{marginTop: `${headerHeight}px`}}>
					{children}
				</div>
				<Switch>
					{config.map(c => (<Route {...c.route} pPerformance={c.pPerformance}>
						<Footer {...c.footer} pPerformance={c.pPerformance} />
					</Route>))}
					<Route >
						<Footer show />
					</Route>
				</Switch>
			</div>
		</RouterWrapper>);
	}
}

export default Shell;



// WEBPACK FOOTER //
// ../q-components/components/shell/index.js